import React from "react";

import PageHeading from "2g-page-heading";

import RezervaceWidgetNejblizsi from "b2b/components/rezervace-widget/RezervaceWidgetNejblizsi";

export function RezervaceWidgetExample() {
  return (
    <>
      <PageHeading>RezervaceWidget</PageHeading>
      <div data-testid="RezervaceWidgetNejblizsi">
        <RezervaceWidgetNejblizsi />
      </div>
    </>
  );
}

RezervaceWidgetExample.propTypes = {};

export default React.memo(RezervaceWidgetExample);
